export default "__VITE_ASSET__DRtNgdIK__";